import { THEME_COLORS } from '@st/theme/colors'
import { Rect } from '@st/geom'
import { StampTemplate, TextStampTemplateSection } from '~/st-doc-viewer/annotations'
import { recomputeStampLayoutAndStyle } from '../stamps-core/stamp-layout'
import { StampAnnotation } from '@st/sdk'

const RED = THEME_COLORS['red'][600]
const BLACK = '#000000'
const WHITE = '#ffffff'

const ZERO_RECT: Rect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
}

type TextStamp = {
  text: string
  label: string
}

type NumberStamp = {
  text: string
  label: string
}

export const CHECKMARK_TICK_STAMP: StampTemplate = {
  id: '✓',
  label: '✓',
  category: 'checkmark',
  annotation: recomputeStampLayoutAndStyle({
    id: '✓',
    text: '✓',
    time: '2000-01-01T00:00:00.000Z',
    stampType: 'tick_mark',
    stampSize: 20,
    color: RED,
    bounds: ZERO_RECT,
    type: 'stamp',
    pageNumber: 1,
    font: {
      family: 'Helvetica',
      size: -1,
      weight: 'normal'
    }
  })
}

const STANDALONE_STAMPS: StampTemplate[] = [CHECKMARK_TICK_STAMP]

const TEXT_STAMPS: TextStamp[] = [
  {
    text: 'DUP',
    label: 'Duplicate'
  },
  {
    text: 'DUP!',
    label: 'Duplicate - Conflicting'
  },
  {
    text: 'NTE',
    label: 'No Tax Effect'
  },
  {
    text: 'T',
    label: 'Totaled'
  },
  {
    text: 'TR',
    label: 'Tax Return'
  },
  {
    text: 'PBC',
    label: 'Prepared by Client'
  },
  {
    text: 'R',
    label: 'Reviewed'
  },
  {
    text: 'V',
    label: 'Verified'
  },
  {
    text: '?',
    label: 'Unclear'
  }
]

const NUMBER_STAMPS: NumberStamp[] = [
  {
    text: '1',
    label: 'One'
  },
  {
    text: '2',
    label: 'Two'
  },
  {
    text: '3',
    label: 'Three'
  },
  {
    text: '4',
    label: 'Four'
  },
  {
    text: '5',
    label: 'Five'
  }
]

export const TICK_MARK_STAMP_TEMPLATE_SECTIONS: TextStampTemplateSection[] = [
  {
    title: 'Stamps',
    layout: 'rows',
    templates: TEXT_STAMPS.map((stamp) => ({
      id: stamp.text,
      label: stamp.label,
      category: 'tick_mark',
      annotation: recomputeStampLayoutAndStyle({
        id: stamp.text,
        text: stamp.text,
        time: '2000-01-01T00:00:00.000Z',
        stampType: 'tick_mark',
        stampSize: 16,
        color: RED,
        bounds: ZERO_RECT,
        type: 'stamp',
        pageNumber: 1,
        font: {
          family: 'Helvetica',
          size: -1,
          weight: 'normal'
        }
      })
    }))
  },
  {
    title: 'Numbers',
    layout: 'grid',
    templates: NUMBER_STAMPS.map((stamp) => ({
      id: stamp.text,
      label: stamp.label,
      category: 'tick_mark',
      annotation: recomputeStampLayoutAndStyle({
        id: stamp.text,
        text: stamp.text,
        time: '2000-01-01T00:00:00.000Z',
        stampType: 'number',
        stampSize: 20,
        color: BLACK,
        backgroundColor: WHITE,
        bounds: ZERO_RECT,
        border: {
          color: RED,
          width: 2,
          radius: 10
        },
        type: 'stamp',
        pageNumber: 1,
        font: {
          family: 'Helvetica',
          size: -1,
          weight: 'normal'
        }
      })
    }))
  }
]

// reference templates removed

export function findMatchingTemplate(
  annotation: StampAnnotation | undefined
): StampTemplate | undefined {
  if (!annotation) {
    return undefined
  }

  for (const template of STANDALONE_STAMPS) {
    if (templateMatches(template, annotation)) {
      return template
    }
  }

  for (const section of TICK_MARK_STAMP_TEMPLATE_SECTIONS) {
    for (const template of section.templates) {
      if (templateMatches(template, annotation)) {
        return template
      }
    }
  }

  function templateMatches(template: StampTemplate, annotation: StampAnnotation) {
    return (
      template.annotation.text == annotation.text &&
      template.annotation.stampType == annotation.stampType
    )
  }
}
